<template>
    <div class="px-6 surface-overlay relative">
        <div class="py-0 lg:py-0 px-6 flex align-items-center justify-content-between lg:static">
            <div class="flex align-items-center">
                <a v-ripple class="cursor-pointer block lg:hidden text-700 p-ripple"
                   v-styleclass="{ selector: '#navbar-8', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-bars text-4xl"></i>
                </a>
            </div>
        </div>
        <div id="navbar-8"
             class="py-0 hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 surface-border">
            <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                <li>
                    <a @click="processBasic" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Basic</span>
                    </a>
                </li>
                <li>
                    <a @click="processBusiness" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Business</span>
                    </a>
                </li>
                <li>
                    <a @click="processBankAccounts" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Bank Accounts</span>
                    </a>
                </li>
                <li>
                    <a @click="processPractitioners" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Practitioners</span>
                    </a>
                </li>
                <li>
                    <a @click="processBilling" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Billing</span>
                    </a>
                </li>
                <li>
                    <a @click="processEmail" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Email</span>
                    </a>
                </li>
                <li>
                    <a @click="processLocations" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Locations</span>
                    </a>
                </li>
                <li>
                    <a @click="processTemplates" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Templates</span>
                    </a>
                </li>
<!--                <li>-->
<!--                    <a @click="processForms" v-ripple-->
<!--                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                        <i class="pi pi-users mr-2"></i>-->
<!--                        <span>Forms</span>-->
<!--                    </a>-->
<!--                </li>-->
                <li>
                    <a @click="processNoteTemplates" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Note Templates</span>
                    </a>
                </li>
                <li>
                    <a @click="processProvisions" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Provisions</span>
                    </a>
                </li>
<!--                <li>-->
<!--                    <a @click="processTemplates" v-ripple-->
<!--                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">-->
<!--                        <i class="pi pi-users mr-2"></i>-->
<!--                        <span>Provisions</span>-->
<!--                    </a>-->
<!--                </li>-->
            </ul>
        </div>
    </div>
</template>


<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[MenuConfiguration][mounted] System is active.");
                console.log("[MenuConfiguration][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[MenuConfiguration][mounted] System is NOT active.");
                console.log("[MenuConfiguration][mounted] Error = ", e);

                this.userStore.clearUser;
                this.$router.push("login");
            });

        if (this.userStore.user === undefined) {
            console.log("[MenuConfiguration][mounted] User is NOT defined.");

            this.userStore.clearUser;
            this.$router.push('login');
        } else {
            console.log("[MenuConfiguration][mounted] User is defined. this.userStore.user.id = ", this.userStore.user.id);

            UserService.getUser(this.userStore.user.id)
                .then(data => {
                    this.profile = data.data;
                    console.log("[MenuConfiguration][mounted] Data = ", data);

                })
                .catch(e => {
                    console.log("[MenuConfiguration][mounted] No user data found.");
                    console.log("[MenuConfiguration][mounted] Error = ", e);

                    this.userStore.clearUser;
                    this.$router.push('login');
                });
        }
    },
    data() {
        return {
            profile: {},
        }
    },
    methods: {
        processBasic() {
            console.log("[MenuConfiguration][processBasic] Beginning.");
            window.location.href = "/#/commonConfigurationBasic";
        },
        processBusiness() {
            console.log("[MenuConfiguration][processBusiness] Beginning.");
            window.location.href = "/#/commonConfigurationBusiness";
        },
        processBankAccounts() {
            console.log("[MenuConfiguration][processBankAccounts] Beginning.");
            window.location.href = "/#/commonConfigurationBankAccounts";
        },
        processPractitioners() {
            console.log("[MenuConfiguration][processPractitioners] Beginning.");
            window.location.href = "/#/healthConfigurationPractitioners";
        },
        processBilling() {
            console.log("[MenuConfiguration][processBilling] Beginning.");
            window.location.href = "/#/commonConfigurationBilling";
        },
        processEmail() {
            console.log("[MenuConfiguration][processEmail] Beginning.");
            window.location.href = "/#/commonConfigurationEmail";
        },
        processLocations() {
            console.log("[MenuConfiguration][processLocations] Beginning.");
            window.location.href = "/#/commonConfigurationLocations";
        },
        processTemplates() {
            console.log("[MenuConfiguration][processTemplates] Beginning.");
            window.location.href = "/#/commonConfigurationTemplates";
        },
        processForms() {
            console.log("[MenuConfiguration][processForms] Beginning.");
            window.location.href = "/#/commonConfigurationForms";
        },
        processNoteTemplates() {
            console.log("[MenuConfiguration][processNoteTemplates] Beginning.");
            window.location.href = "/#/commonConfigurationNoteTemplates";
        },
        processProvisions() {
            console.log("[MenuConfiguration][processProvisions] Beginning.");
            window.location.href = "/#/commonConfigurationProvisions";
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
